module.exports = __webpack_public_path__ + "media/images/riders/AARON_GWIN-7d6ca92f530754faf69a3c13184d1ede.png";